import { createContext, useState } from 'react';

export const GlobalContext = createContext({
  likeCount : 0,
  incrementLikeCount: () => {},
  updateLikeCount: (count) => {},
});

function GlobalContextProvider({ children }) {
  const [GblLikeCount, setGblLikeCount] = useState();

  function updateLikeCount(count) {
    setGblLikeCount(count);
    console.log('UPDATE///////',GblLikeCount)
  }

  async function incrementLikeCount() {
    setGblLikeCount(GblLikeCount => GblLikeCount + 1);
    console.log(GblLikeCount);
  }

  const value = {
    likeCount: GblLikeCount,
    incrementLikeCount: incrementLikeCount,
    updateLikeCount : updateLikeCount
  };

  return <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>;
}

export default GlobalContextProvider;